export enum SurveyQuestionTypeEnum {
  Text = 'text',
  Boolean = 'boolean',
  SingleChoice = 'single_choice',
  MultipleChoice = 'multiple_choice',
  Scale = 'scale',
  Stars = 'stars',
  Number = 'number',
  Date = 'date',
}

export const SurveyQuestionTypeEnumLabels: Record<SurveyQuestionTypeEnum, string> = {
  [SurveyQuestionTypeEnum.Text]: 'Texto',
  [SurveyQuestionTypeEnum.Boolean]: 'Sí / No',
  [SurveyQuestionTypeEnum.SingleChoice]: 'Opción única',
  [SurveyQuestionTypeEnum.MultipleChoice]: 'Opción múltiple',
  [SurveyQuestionTypeEnum.Scale]: 'Escala',
  [SurveyQuestionTypeEnum.Stars]: 'Estrellas',
  [SurveyQuestionTypeEnum.Number]: 'Número',
  [SurveyQuestionTypeEnum.Date]: 'Fecha',
};

export function hasEditableResponseOptions(type: SurveyQuestionTypeEnum): boolean {
  return type === SurveyQuestionTypeEnum.SingleChoice || type === SurveyQuestionTypeEnum.MultipleChoice;
}
